import ErrorModal from '../../../components/modal/ErrorModal';
import SuccessModal from '../../../components/modal/SuccessModal';
import InvestmentNoteFiltering from '../../../components/InvestmentNoteFiltering';

import ROUTE_NAME from '../../../routes/RouteName';
import useInvestmentNoteFilter from '../../../hooks/useInvestmentNoteFilter';
import NewOpportunity from './NewOpportunity';
import { useNavigate } from 'react-router-dom';

const ListNote = (props) => {
    const {
        investmentNotes,
        investmentNoteCount,
        filterInvestmentNotes,
        isFetching,
        page,
        setPage,
        pageCount,
        isSuccessModalOpen,
        isErrorModalOpen,
        errorMsg,
        onCloseSuccessModal,
        onCloseErrorModal,
    } = props;

    const navigate = useNavigate();

    return (
        <>
            <InvestmentNoteFiltering
                filterInvestmentNotes={filterInvestmentNotes}
            />
            {/* Investment Success Modal */}
            <SuccessModal
                isOpen={isSuccessModalOpen}
                toggle={() => {
                    onCloseSuccessModal();
                    navigate(ROUTE_NAME.INVEST_NOW_MANUAL);
                }}
                title="Investment"
                message="Your amount is successfully invested. Thank you."
            />
            {/* End Investment Success Modal */}

            {/* Error Modal */}
            <ErrorModal
                isOpen={isErrorModalOpen}
                toggle={onCloseErrorModal}
                title="Error"
                message={errorMsg}
            />
            {/* End Error Modal */}

            <div
                className="tabs tabs--bordered-bottom list-desktop-notes-invest mx-2 d-flex flex-grow-1 flex-column"
                style={{ overflowY: 'hidden' }}
            >
                {/* <NavTab />
                <TabContent className="d-flex flex-grow-1 flex-column">
                    <TabPane className="d-flex flex-grow-1 flex-column">
                        <Switch>
                            <Route path={ROUTE_NAME.INVEST_NOW_MANUAL}>
                                <NewOpportunity
                                    valueReturnFilter={
                                        investmentNoteFilter.return
                                    }
                                    themeFilter={investmentNoteFilter.theme}
                                    searchFilter={investmentNoteFilter.search}
                                />
                            </Route>
                            <Route path={ROUTE_NAME.INVEST_NOW}>
                                <AutoInvest />
                            </Route>
                        </Switch>
                    </TabPane>
                </TabContent> */}
                <NewOpportunity
                    investmentNotes={investmentNotes}
                    isFetching={isFetching}
                    page={page}
                    setPage={setPage}
                    pageCount={pageCount}
                />
            </div>
        </>
    );
};

export default ListNote;
